export default ({ request }) => ({
  stockChangeLogListApi(data = {}) {
    return request({
      url: "/digitalCenter/fabric/stock/change/log/list",
      method: "post",
      data,
    });
  },
  stockChangeLogDetailApi(data = {}) {
    return request({
      url: "/digitalCenter/fabric/stock/change/log/detail",
      method: "post",
      data,
    });
  },
});
